/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: '/admin/flow-meter',
    name: 'หน้าหลัก',
    slug: 'external',
    icon: 'HomeIcon',
  },
  {
    url: '/admin/flow-meter/monitoring',
    name: 'ระบบติดตามตำแหน่งเรือ',
    slug: 'external',
    icon: 'MapIcon',
  },
  {
    url: '/admin/flow-meter/oil-transfers',
    name: 'ข้อมูลการโหลดน้ำมัน',
    slug: 'external',
    icon: 'FileIcon',
    // i18n: 'Report',
    // submenu: [
    //   {
    //     url: '/vesselTrackingReport',
    //     name: 'VesselTrackingReport',
    //     slug: 'external',
    //     icon: '',
    //     i18n: 'VesselTrackingReport',
    //   },
    //   {
    //     url: null,
    //     name: 'OilDistributionReport',
    //     slug: 'external',
    //     icon: '',
    //     i18n: 'OilDistributionReport',
    //     submenu: [
    //       {
    //         url: '/oil_distribution/refinery',
    //         name: 'RefineryOilTransfer',
    //         slug: 'external',
    //         icon: 'FileIcon',
    //         i18n: 'OilTransferRefinery',
    //       },
    //       {
    //         url: '/oil_distribution/forward_tanker',
    //         name: 'ForwardTankerOilTransfer',
    //         slug: 'external',
    //         icon: '',
    //         i18n: 'OilTransferTanker',
    //       },
    //       {
    //         url: '/oil_distribution/tanker',
    //         name: 'TankerOilTransfer',
    //         slug: 'external',
    //         icon: '',
    //         i18n: 'OilTransferForwardTanker',
    //       },
    //       {
    //         url: '/oil_distribution/vessel',
    //         name: 'VesselOilTransfer',
    //         slug: 'external',
    //         icon: '',
    //         i18n: 'OilTransferVessel',
    //       },
    //     ],
    //   },
    // ],
  },
  // {
  //   url: null,
  //   name: 'OverflowTransfer',
  //   slug: 'external',
  //   icon: 'LayersIcon',
  //   i18n: 'Behavior',
  //   submenu: [
  //     // {
  //     //   url: '/behavior/over_flow_transfer',
  //     //   name: "OverflowTransfer",
  //     //   slug: "external",
  //     //   icon: "",
  //     //   i18n: "OverflowTransfer",
  //     // },
  //     {
  //       url: '/behavior/monthly_occurrence',
  //       name: 'MonthlyOccurrence',
  //       slug: 'external',
  //       icon: '',
  //       i18n: 'MonthlyOccurrence',
  //     },
  //   ],
  // },
  // {
  //   url: '/admin/users',
  //   name: 'users',
  //   slug: 'external',
  //   icon: 'UsersIcon',
  //   i18n: 'RegistrationUser',
  // },
]
